import styled from 'styled-components';
import { color } from './academy-styles';

const CertPassedIcon = ({ className }) => (
  <StyledSvg className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="circle__x--fill">
      <path
        id="Subtract"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM7.35355 10.3536L11.3536 6.35355L10.6464 5.64645L7 9.29289L5.35355 7.64645L4.64645 8.35355L6.64645 10.3536L7 10.7071L7.35355 10.3536Z"
        fill={color.certPassed}
      />
    </g>
  </StyledSvg>
);

const CertFailedIcon = ({ className }) => (
  <StyledSvg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="circle__check--fill">
      <path
        id="Subtract"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM4.64645 5.35355L7.29289 8L4.64645 10.6464L5.35355 11.3536L8 8.70711L10.6464 11.3536L11.3536 10.6464L8.70711 8L11.3536 5.35355L10.6464 4.64645L8 7.29289L5.35355 4.64645L4.64645 5.35355Z"
        fill={color.certFailed}
      />
    </g>
  </StyledSvg>
);

const CertRequiresGradingIcon = ({ className }) => (
  <StyledSvg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="circle__pending--fill">
      <path
        id="Subtract"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM6 8C6 8.55229 5.55228 9 5 9C4.44772 9 4 8.55229 4 8C4 7.44772 4.44772 7 5 7C5.55228 7 6 7.44772 6 8ZM9 8C9 8.55229 8.55229 9 8 9C7.44772 9 7 8.55229 7 8C7 7.44772 7.44772 7 8 7C8.55229 7 9 7.44772 9 8ZM11 9C11.5523 9 12 8.55229 12 8C12 7.44772 11.5523 7 11 7C10.4477 7 10 7.44772 10 8C10 8.55229 10.4477 9 11 9Z"
        fill={color.certRequiresGrading}
      />
    </g>
  </StyledSvg>
);

export { CertPassedIcon, CertFailedIcon, CertRequiresGradingIcon };

const StyledSvg = styled.svg`
  width: 22px;
  height: 22px;
`;
